// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"rZmw","container":"VR3L","breadcrumb":"gEGq","breadcrumbs-container":"Fjzc","breadcrumbsContainer":"Fjzc","link":"AkiM","last":"grdH"};